import React from "react";
import { ArrowUp, ArrowDown, Circle, AlertTriangle, Flag, Check, X as XIcon, Minus } from "lucide-react";

export const COND_ICONS = { arrow_up: ArrowUp, arrow_down: ArrowDown, circle: Circle, triangle: AlertTriangle, flag: Flag, check: Check, x: XIcon, minus: Minus };

export function CondIcon({ fx, size = "w-3 h-3" }) {
  if (!fx?.icon) return null;
  const I = COND_ICONS[fx.icon] || Circle;
  const right = fx.iconPos === "right";
  return <I className={`${size} inline-block ${right ? "ml-1" : "mr-1"} shrink-0 align-[-1px]`} style={{ color: fx.iconColor }} fill={fx.icon === "circle" ? fx.iconColor : "none"} />;
}
